;(function (W, $, D, Drupal) {

  'use strict'

  if (typeof W.sg === 'undefined') {
    W.sg = {}
  }

  let sg = W.sg, $D = $(D), $root = $('.paragraph--type--liste-implantations')
  const oComponents = sg.components, oUtils = sg.utils

  let listImplantations = (() => {

    /**
     * @function _initAccordion
     * Show/hide contact informations
     */
    let _initAccordion = () => {
      oComponents.accordion.init($root.find('.accordion'))
    },

    /**
     * @function _initAccordion
     * Show/hide detail implantation
     */
    _toggleInfos = () => {
      $root.find('.more-infos').on('click', (e) => {
        let $btn = $(e.currentTarget),
            target = $btn.attr('aria-controls')
        
        $('#' + target).slideToggle()

        $btn.toggleClass('active')
        let btnLabel = ($btn.hasClass('active')) ? Drupal.t('Moins d’info', {}, {'context' : 'accessibilite'}) : Drupal.t('Plus d’info', {}, {'context' : 'accessibilite'})
        $btn.text(btnLabel)

        oUtils.toggleAriaExpanded($btn)
      })
    },

    oMod = {
      init: () => {
        _initAccordion()
        _toggleInfos()
      }
    }

    return oMod
  })()

  $D.ready(function () {
    listImplantations.init()
  })
  
})(window, window.jQuery, document, window.Drupal)
